import { lazy } from "react";

const create = lazy(() => import("./Create").then(m => ({ default: m.FamilyCreate })));
const edit = lazy(() => import("./Edit").then(m => ({ default: m.FamilyEdit })));

export default { create, edit };
